import { AutoIncrementingID } from "./AutoIncrementingID.js";
/**
 * Subscriptable
 *
 * Storage for the `EventEmitter`'s listeners. The `Subscriptable`
 * is an extension of the map prototype that provides ordered
 * indexing of callbacks with unique identifier for each index
 */
export class Subscriptable {
    storage = new Map();
    IDs = new AutoIncrementingID();
    /**
     * Register
     *
     * Indexes a callback on the map and returns its unique
     * identifier
     */
    register(callback) {
        const ID = this.IDs.get();
        this.storage.set(ID, callback);
        return ID;
    }
    /**
     * Remove
     *
     * Deletes a callback by ID. Returns true if a callback with
     * a corresponding ID existed, or false if it does not
     */
    remove(ID) {
        return this.storage.delete(ID);
    }
    /**
     * Execute
     *
     * Iterates over each lister on the map and executes it with
     * the provided parameters
     */
    execute(...params) {
        for (const listener of this) {
            void listener(...params);
        }
    }
    /**
     * Execute Blocking
     *
     * Iterates over each lister on the map and executes it. Using
     * this method will cause asynchronous operations to be handled
     * as sequential blocking tasks
     */
    async executeBlocking(...params) {
        for (const listener of this) {
            await listener(...params);
        }
    }
    /**
     * Execute Concurrent
     *
     * Iterates over each lister on the map and executes it. Using
     * this method will cause asynchronous operations to be handled
     * concurrently
     */
    async executeConcurrent(...params) {
        const tasks = [];
        for (const listener of this) {
            tasks.push(listener(...params));
        }
        return Promise.all(tasks);
    }
    /**
     * Length
     *
     * Returns the number of entries on the instance
     */
    get length() {
        return this.storage.size;
    }
    *[Symbol.iterator]() {
        for (const [_, listener] of this.storage) {
            yield listener;
        }
    }
}
